import { ITcmEquipmentKeyTypes } from 'types/graphqlTypes'
import { IEquipmentTypes } from '../../types'

export const TCM_EQUIPMENT: Record<IEquipmentTypes, ITcmEquipmentKeyTypes | null> = {
  [IEquipmentTypes.anyEquipment]: null,
  [IEquipmentTypes.dryVan]: ITcmEquipmentKeyTypes.dry_van,
  [IEquipmentTypes.reefer]: ITcmEquipmentKeyTypes.reefer,
  [IEquipmentTypes.openDeck]: null,
}

export type TTcmEquipment = typeof TCM_EQUIPMENT
